import { Skeleton } from "@mui/material";
import { type FC } from "react";
import { TriggerArrowDown } from "../../../../Link/Trigger";

interface LoadMoreButtonProps {
	fetchMore: () => void;
	loading: boolean;
}

const LoadMoreButton: FC<LoadMoreButtonProps> = ({
	fetchMore,
	loading,
}) => {
	if (loading) return <Skeleton />;

	return (
		<TriggerArrowDown
			onClick={fetchMore}
			sx={{ alignSelf: "flex-start", py: 4 }}
		>
			Starší pohyby
		</TriggerArrowDown>
	);
};

export default LoadMoreButton;
